/* eslint-disable react/jsx-tag-spacing */ /* for minified SVGs */
import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const GiftTrackerIcon = ({
  title = 'GiftTracker',
  ...props
}: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox="0 0 30 26" {...props}>
    {/* prettier-ignore */}
    <g fill="none" fillRule="nonzero"><path d="M0 0h30v30H0z"/><g fill="currentColor"><path d="M4 1.5a.5.5 0 00-.5.5v8a.5.5 0 00.5.5h8a.5.5 0 00.5-.5V2a.5.5 0 00-.5-.5H4zM4 0h8a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V2a2 2 0 012-2zM18 1.5a.5.5 0 00-.5.5v8a.5.5 0 00.5.5h8a.5.5 0 00.5-.5V2a.5.5 0 00-.5-.5h-8zM18 0h8a2 2 0 012 2v8a2 2 0 01-2 2h-8a2 2 0 01-2-2V2a2 2 0 012-2zM4 15.5a.5.5 0 00-.5.5v8a.5.5 0 00.5.5h8a.5.5 0 00.5-.5v-8a.5.5 0 00-.5-.5H4zM4 14h8a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2v-8a2 2 0 012-2zM18 15.5a.5.5 0 00-.5.5v8a.5.5 0 00.5.5h8a.5.5 0 00.5-.5v-8a.5.5 0 00-.5-.5h-8zm0-1.5h8a2 2 0 012 2v8a2 2 0 01-2 2h-8a2 2 0 01-2-2v-8a2 2 0 012-2z"/></g></g>
  </CreateIconComponent>
);

export default GiftTrackerIcon;
